<template>
  <div class="viewcontent" v-if="translations.event && translations.buttons">
    <h2>
      {{ translations.event.title_share }}
      <hr class="bg-secondary border-2 border-top border-secondary" />
    </h2>
    <div class="col-12">
      <button
        class="btn btn-primary mx-2"
        type="button"
        @click="shareOption(1)"
        :disabled="checkDisabled(1)"
      >
        {{ translations.buttons.btn_link }}
      </button>
      <button
        class="btn btn-primary mx-2"
        type="button"
        @click="shareOption(2)"
        :disabled="checkDisabled(2)"
      >
        {{ translations.buttons.btn_html }}
      </button>
      <button
        class="btn btn-primary mx-2"
        type="button"
        @click="shareOption(3)"
        :disabled="checkDisabled(3)"
      >
        {{ translations.buttons.btn_result }}
      </button>
    </div>
    <div class="col-12 pt-2" v-if="checkPreview">
      <h3 class="mt-3">
        {{ defineTitle }}
      </h3>
      <div class="alert alert-secondary" role="alert">
        <iframe
          v-if="copyed.preview"
          class="w-100"
          :src="'https://festapp.cat/' + this.event.code"
        ></iframe>
        <p v-if="copyed.link" class="form-control">
          {{ 'https://festapp.cat/' + this.event.code }}
        </p>
        <pre v-if="copyed.code" class="form-control" disabled>
&lt;iframe src="https://festapp.cat/{{
            this.event.code
          }}"&gt;&lt;/iframe&gt;</pre
        >
      </div>
    </div>
    <div class="col-12 pt-2">
      <button class="btn btn-danger mx-2" type="button" @click="cancel()">
        {{ translations.buttons.btn_exit }}
      </button>
    </div>
  </div>
</template>

<script>
  import { mapActions, mapState } from 'vuex'

  export default {
    name: 'ToolEventShare',
    data() {
      return {
        copyed: {
          link: false,
          code: false,
          preview: false,
        },
      }
    },
    computed: {
      ...mapState(['event', 'translations']),
      checkPreview() {
        return (
          (this.event.code && this.copyed.link) ||
          this.copyed.code ||
          this.copyed.preview
        )
      },
      defineTitle() {
        if (this.translations.info) {
          let result = ''
          if (this.copyed.preview) {
            result = this.translations.info.preview
          } else if (this.copyed.code) {
            result = this.translations.info.html_copied
          } else {
            result = this.translations.info.link_copied
          }
          return result
        }
      },
    },
    methods: {
      ...mapActions(['changeToolSelected', 'getEvent']),
      cancel() {
        this.changeToolSelected(null)
      },
      shareOption(option) {
        let text = ''
        switch (option) {
          case 1:
            text = 'https://festapp.cat/' + this.event.code
            this.copyed.link = true
            this.copyed.preview = false
            this.copyed.code = false
            break
          case 2:
            text =
              '<iframe src="https://festapp.cat/' +
              this.event.code +
              '"></iframe>'
            this.copyed.code = true
            this.copyed.link = false
            this.copyed.preview = false
            break
          case 3:
            text =
              '<iframe src="https://festapp.cat/' +
              this.event.code +
              '"></iframe>'
            this.copyed.preview = true
            this.copyed.code = false
            this.copyed.link = false
            break
        }
        this.copyToClipboard(text)
      },
      checkDisabled(option) {
        let result = false
        switch (option) {
          case 1:
            result = this.copyed.link
            break
          case 2:
            result = this.copyed.code

            break
          case 3:
            result = this.copyed.preview

            break
        }
        return result
      },
      copyToClipboard(text) {
        if (navigator.clipboard && window.isSecureContext) {
          const clipboardData =
            event.clipboardData ||
            window.clipboardData ||
            event.originalEvent?.clipboardData ||
            navigator.clipboard

          clipboardData.writeText(text)
        }
      },
    },
    async created() {
      await this.getEvent({ id: this.$route.params.id, type: 'get' })
    },
  }
</script>

<style scoped>
  iframe {
    pointer-events: none;
    height: 300px;
  }
</style>
